/**
 * Autogenerated file.
 * For adding or changing icons, see README.MD
 */
import React from 'react';
import { createIcon } from '../../icon/create-icon';
// Outline
const WarningOutline = props => (/*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  stroke: "var(--i-color)",
  strokeLinecap: props.strokeLinecap,
  strokeLinejoin: props.strokeLinejoin,
  strokeWidth: "var(--i-s-width)",
  d: "M12 10.125v3.75m-1.29-9.75-8.25 14.25c-.14.23-.2.49-.2.75s.06.52.2.75c.13.23.31.42.54.55s.49.2.75.2h16.5c.26 0 .52-.07.75-.2s.41-.32.55-.55c.13-.23.2-.49.19-.75 0-.26-.06-.52-.2-.75l-8.25-14.25c-.13-.23-.31-.42-.54-.55s-.49-.2-.75-.2-.52.07-.75.2a1.5 1.5 0 0 0-.54.55z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "var(--i-color)",
  d: "M12 18.185c.52 0 .94-.42.94-.93a.939.939 0 1 0-1.88 0c0 .51.42.93.94.93z"
})));
// Fill
const WarningFill = props => (/*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  fill: "var(--i-color)",
  d: "m22.19 18.005-8.24-14.25c-.2-.35-.48-.63-.82-.83-.35-.2-.73-.3-1.13-.3s-.78.1-1.13.3c-.34.2-.62.48-.82.83l-8.24 14.25c-.2.34-.31.72-.31 1.12 0 .39.1.78.3 1.13.2.34.48.62.82.82.35.2.73.3 1.13.3h16.5c.4 0 .78-.1 1.13-.3.34-.2.62-.48.82-.82.2-.35.3-.74.3-1.13 0-.4-.11-.78-.31-1.12zm-10.94-7.88a.75.75 0 0 1 1.5 0v3.75a.75.75 0 0 1-1.5 0v-3.75zm.75 8.25c-.22 0-.44-.07-.63-.19-.18-.12-.32-.3-.41-.5-.08-.21-.11-.44-.06-.65.04-.22.15-.42.3-.58.16-.16.36-.26.58-.31.22-.04.44-.02.65.07.21.08.38.23.51.41.12.19.18.4.18.63 0 .29-.11.58-.32.79-.22.21-.5.33-.8.33z"
})));
// DuoTone
const WarningDuotone = props => (/*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  fill: "var(--i-color)",
  d: "m10.71 4.125-8.25 14.25c-.14.23-.2.49-.2.75s.06.52.2.75c.13.23.31.42.54.55s.49.2.75.2h16.5c.26 0 .52-.07.75-.2s.41-.32.55-.55c.13-.23.2-.49.19-.75 0-.26-.06-.52-.2-.75l-8.25-14.25c-.13-.23-.31-.42-.54-.55s-.49-.2-.75-.2-.52.07-.75.2a1.5 1.5 0 0 0-.54.55z",
  opacity: 0.2
}), /*#__PURE__*/React.createElement("path", {
  stroke: "var(--i-color)",
  strokeLinecap: props.strokeLinecap,
  strokeLinejoin: props.strokeLinejoin,
  strokeWidth: "var(--i-s-width)",
  d: "M12 10.135v3.74m-1.29-9.75-8.25 14.25c-.14.23-.2.49-.2.75s.06.52.2.75c.13.23.31.42.54.55s.49.2.75.2h16.5c.26 0 .52-.07.75-.2s.41-.32.55-.55c.13-.23.2-.49.19-.75 0-.26-.06-.52-.2-.75l-8.25-14.25c-.13-.23-.31-.42-.54-.55s-.49-.2-.75-.2-.52.07-.75.2a1.5 1.5 0 0 0-.54.55z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "var(--i-color)",
  d: "M12 18.375c.62 0 1.12-.5 1.12-1.12a1.12 1.12 0 1 0-2.24 0c0 .62.5 1.12 1.12 1.12z"
})));
/**
  Icon WarningIcon in security group
*/
export const WarningIcon = createIcon('WarningIcon', 'warning', 'security', WarningOutline, WarningFill, WarningDuotone, "0 0 24 24");